const scrollingPaginationDuration = 300;

export const indexSmallBannersSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        768: 2.6,
        700: 2.4,
        550: 1.8,
        400: 1.4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
        }
    }

    return {
        loop: false,
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: 12,
        centeredSlides: false,
        breakpoints: breakpoints
    }
}

export const indexBannerSliderOptions = (instance, options, labels) => {
    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true
        },
        loop: true,
        autoHeight: true,
        effect: 'fade',
        pagination: {
            el: instance.paginationEl,
            clickable: true,
            hideOnClick: false,
            renderBullet: function (index, className) {
                return '<div class="' + className + '"><div class="swiper-bullet-content">' + labels[index]  + '</div></div>';
            }
        },
        on: {
            slideChange: function () {
                const $activeBullet = $(instance.paginationEl).find('.swiper-pagination-bullet-active');
                if (window.innerWidth > 768 && $activeBullet.length) {
                    const $paginationEl = $(instance.paginationEl);
                    const bulletOffsetTop = $activeBullet.offset().top;
                    const parentOffsetTop = $paginationEl.offset().top;
                    const scrollTop = $paginationEl.scrollTop();
                    const bulletHeight = $activeBullet.outerHeight();
                    const parentHeight = $paginationEl.outerHeight();

                    if (bulletOffsetTop < parentOffsetTop) {
                        $paginationEl.animate({
                            scrollTop: scrollTop - (parentOffsetTop - bulletOffsetTop)
                        }, scrollingPaginationDuration);
                    }

                    if (bulletOffsetTop + bulletHeight > parentOffsetTop + parentHeight) {
                        $paginationEl.animate({
                            scrollTop: scrollTop + (bulletOffsetTop + bulletHeight - (parentOffsetTop + parentHeight))
                        }, scrollingPaginationDuration);
                    }
                }
            }
        }
    }
}